import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";

/**
 * Selector for notification
 */
export const listChart = createFeatureSelector<GenericStoreApiData>(
  AppSettings.KEY_CHART
);
